import { gql } from '@apollo/client'
import React from 'react'
import StatePresenter from '../../../../../../packages/kiti/components/helpers/StatePresenter'
import { sessionsClient } from '../../../../../../utils/apollo/api'
import { useQuery } from '../../../../../../utils/apollo/_helpers/useQuery'
import { useModalData } from '../../../../../../components/modals/ModalsContext'

const Context = React.createContext([])
const { Provider } = Context
export const useWebhookState = () => React.useContext(Context)
export const useWebhook = () => useWebhookState()?.publicToken

const QUERY = gql`
  query PublicToken($id: ID) {
    publicToken(id: $id, filter: { includeDisabled: true }) {
      id
      name
      type
      action
      amountLeft
      conditions
      payload
    }
  }
`

const WebhookLoader = ({ children }) => {
  const { id } = useModalData()

  const { data, ...state } = useQuery(QUERY, {
    skip: !id,
    variables: { id },
    client: sessionsClient,
    fetchPolicy: 'network-only'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default WebhookLoader
